import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
} from '@angular/core';
import { MibBadgeDirective } from '@medinbox/angular';

@Component({
  selector: 'mai-count-badges',
  imports: [MibBadgeDirective],
  templateUrl: './count-badges.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CountBadges {
  // Make sure those counts are always number, 0 by default (even if we passe something else than a number)
  readonly successCount = input(0, { transform: (value) => numberAttribute(value, 0) });
  readonly warningCount = input(0, { transform: (value) => numberAttribute(value, 0) });

  readonly successCountLimited = computed(() =>
    this.successCount() > 99 ? '99+' : this.successCount(),
  );
  readonly warningCountLimited = computed(() =>
    this.warningCount() > 99 ? '99+' : this.warningCount(),
  );
}
